module.exports = __webpack_public_path__ + "img/global_view_realtime.c9f36628.png";